import React, { Component, createRef } from "react";
import GoogleMapReact, { fitBounds } from "google-map-react";
import _ from "lodash";

import Car from "../../assets/car.svg";
import Hotel from "../../assets/hotel.svg";

import { Link } from "react-router-dom";
import settings from "../../settings";

const AnyReactComponent = ({ text, img }) => (
  <div className="marker">
    {img && <img src={img} alt="marker icon" />}
    {text}
  </div>
);

class GPSMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      bounds: {
        ne: { lat: 0, lng: 0 },
        sw: { lat: 0, lng: 0 },
      },
      dataload: null,
      isLoaded: false,
    };
    this.containerRef = createRef();
  }

  componentDidMount() {
    this.loadData();
    const dataload = setInterval(this.loadData.bind(this), 1000 * 60 * 5.1);
    this.setState({ dataload });
  }

  componentWillUnmount() {
    if (this.state.dataload) {
      clearInterval(this.state.dataload);
    }
  }

  async loadData() {
    try {
      const response = await fetch(
        settings.server_url +
          "get_next_delivery_location/" +
          window.sessionStorage.getItem("sid")
      );
      const data = await response.json();

      let markData = [
        {
          user: data.locationName,
          lat: data.myLocation[0],
          lon: data.myLocation[1],
          img: Hotel,
        },
      ];

      if (data.drivers && data.drivers.length > 0) {
        data.drivers.forEach((driver) => {
          markData.push({
            user: driver.driverName,
            lat: driver.driverLocation[0],
            lon: driver.driverLocation[1],
            img: Car,
          });
        });
      }

      const markers = markData.map((mark) => ({
        text: mark.user,
        img: mark.img,
        lat: parseFloat(mark.lat),
        lng: parseFloat(mark.lon),
      }));

      this.setState({ markers, isLoaded: true }, this.updateBounds);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  updateBounds() {
    const { markers } = this.state;
    if (markers.length === 0) return;

    const latitudes = markers.map((marker) => marker.lat);
    const longitudes = markers.map((marker) => marker.lng);

    const bounds = {
      ne: { lat: Math.max(...latitudes), lng: Math.max(...longitudes) },
      sw: { lat: Math.min(...latitudes), lng: Math.min(...longitudes) },
    };

    this.setState({ bounds });
  }

  render() {
    return (
      <div style={{ height: "calc(100vh - 200px)", width: "100%" }}>
        {this.state.isLoaded && this.state.markers.length > 0 ? (
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyCvuq_EYSsLuOr3HGKl6q2vWfRX_0p4T5c",
            }}
            defaultCenter={{
              lat: this.state.markers[0].lat,
              lng: this.state.markers[0].lng,
            }}
            defaultZoom={11}
            onGoogleApiLoaded={({ map, maps }) => {
              const bounds = new maps.LatLngBounds();
              this.state.markers.forEach((marker) => {
                bounds.extend(new maps.LatLng(marker.lat, marker.lng));
              });
              map.fitBounds(bounds);
            }}
          >
            {this.state.markers.map((mark, i) => (
              <AnyReactComponent
                key={i}
                lat={mark.lat}
                lng={mark.lng}
                text={mark.text}
                img={mark.img}
              />
            ))}
          </GoogleMapReact>
        ) : (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default GPSMap;
